import React from 'react'
import "./Eee.css"
import image_rivercleaning from "../../assets2/nwimage2.jpg"
import image_shoe from "../../assets2/nwimage5.jpg"

import { Link } from 'react-router-dom'
const Eee = () => {
  return (
    <div className='overalleee'>
      <h1>River Cleaning robot</h1>
      <p className='riverpara'>Our IoT-powered River Cleaning Robot is an advanced solution for water pollution control. Designed for efficiency, it autonomously collects floating waste, ensuring clean and healthy water bodies.
       Equipped with a solar-powered system, the robot operates sustainably with extended running hours. Its high-torque motor provides precise direction control, allowing effective navigation in rivers and lakes</p>
      <p className='riverpara'>A durable conveyor belt mechanism ensures seamless waste collection, even in challenging conditions. The long-range IoT connectivity enables real-time monitoring and remote operation, making it ideal for large-scale water management.
       With portable and lightweight construction, the robot can be easily deployed in different water bodies. Its AI-driven obstacle detection system enhances safety and efficiency, preventing collisions with boats and natural obstacles</p>
      
      <div className='riverimg'>
        <img src={image_rivercleaning} alt="" className='riverinnerimg' />
      </div>
      
      <div className='content2eee' data-aos="fade-left">
         <h1>Bionic Leg with Wireless Assist</h1>
         <p className='riverpara'>Our Bionic Leg with Wireless Assist is an advanced prosthetic solution that restores natural movement for amputees. It features intelligent motion control, allowing seamless coordination between the natural and prosthetic leg.
              Using a wireless communication protocol, the system detects the movement of the normal leg and transmits precise stepping signals to the bionic leg. A high-performance motor in the secondary leg ensures synchronized motion, enhancing walking stability and balance</p>
         <p className='riverpara'>The bionic leg is completely battery-operated, providing portability and long-lasting performance. Its lightweight and ergonomic design ensures maximum comfort for users during prolonged use.
              Built with advanced microcontrollers and sensors, it offers real-time gait analysis and adapts dynamically to different walking conditions. The system is easy to calibrate, making it user-friendly for individuals of all ages</p>
         
         <div className='riverimg' data-aos="fade-left">
          <img src={image_shoe} alt="" className='riverinnerimg' />
         </div>
         
         
         <p className='riverpara'>This prosthetic solution is suitable for daily use, offering independence and mobility to amputees. With durable materials and robust construction, it ensures longevity and minimal maintenance requirements</p>
      </div>
     <div className='hrbtns'>
      <hr />
      <button className='buttonforlink'><Link to="/projects" className='spllink2'>Back to projects</Link></button>     
      </div>
    </div>
  )
}

export default Eee